"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtUndoFw = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtUndoFw = function SvgBtUndoFw(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.062 7a7.009 7.009 0 016.897 5.542l1.073-1.81a.532.532 0 01.706-.201.532.532 0 01.202.706l-1.917 3.128c-.101.1-.202.201-.303.201h-.1c-.102 0-.203 0-.303.101l-3.128-1.916a.532.532 0 01-.201-.707.532.532 0 01.706-.202l2.358 1.398c-.405-2.943-2.94-5.231-5.99-5.231-3.33 0-6.053 2.724-6.053 6.053 0 3.33 2.724 6.053 6.053 6.053.303 0 .504.202.504.504 0 .303-.201.505-.504.505A7.018 7.018 0 016 14.062 7.018 7.018 0 0113.062 7z",
    fill: "currentColor"
  }));
};

exports.SvgBtUndoFw = SvgBtUndoFw;